<template>
    <section class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
            </p>
        </div>

        <div class="row mt-1 mb-4">

            <div class="col-12 col-md-6">
                <form class="col-12">
                    <div class="row" style="margin-bottom:0px;">
                        <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="type"/>
                                <select class="form-control  linea-form" 
                                    required 
                                    ref="input_type_update" 
                                    v-model="single_object.speciality_id"
                                    style="font-size:12px;"
                                >
                                    <option value="" disabled selected>Select an option</option>
                                    <option v-for="(value, i) in specialities" :key="i" :value="value.id" v-html="value.name"/>
                                </select>
                            </div>
                        </div>
                            <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="country"/>
                                <select class="form-control  linea-form" 
                                    required 
                                    ref="input_country_update" 
                                    v-model="single_object.country_id"
                                    style="font-size:12px;"
                                >
                                    <option value="" disabled selected></option>
                                    <option v-for="(value, i) in countries" :key="i" :value="value.id" v-html="value.name"/>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-bottom:0px;">
                        
                        <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="state"/>
                                <select class="form-control  linea-form" 
                                    required 
                                    ref="input_state_update" 
                                    v-model="single_object.territory_id" 
                                    style="font-size:12px;"
                                    :disabled="state_countries.length ? false : true"
                                >
                                    <option value="" disabled selected></option>
                                    <option v-for="(value, i) in state_countries" :key="i" :value="value.id" v-html="value.name"/>
                                </select>
                            </div>
                        </div>
                            <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="name"/>
                                <input type="text" 
                                
                                    class="form-control  linea-form" 
                                    style="height: 1rem; font-size:12px;"
                                    required v-model="single_object.name" 
                                    :maxlength="45" 
                                    ref="input_name_update"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-bottom:0px;">
                        
                        <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="address"/>
                                <input type="text" 
                                    
                                    class="form-control  linea-form" 
                                    style="height: 1rem; font-size:12px;"
                                    required 
                                    v-model="single_object.address" 
                                    :maxlength="245"
                                    ref="input_address_update"
                                />
                            </div>
                        </div>
                            <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="zip_code"/>
                                <input type="text" 
                                    
                                    class="form-control  linea-form" 
                                    style="height: 1rem; font-size:12px;"
                                    required v-model="single_object.zip_code" 
                                    :maxlength="15" 
                                    ref="input_zip_code_update"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-bottom:0px;">
                        
                        <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="email"/>
                                <input type="email" 
                                    
                                    class="form-control  linea-form" 
                                    style="height: 1rem; font-size:12px;"
                                    required 
                                    v-model="single_object.email" 
                                    :maxlength="50"
                                    ref="input_email_update"
                                />
                            </div>
                        </div>
                            <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="phone"/>
                                <input type="text" 
                                    
                                    class="form-control  linea-form" 
                                    style="height: 1rem; font-size:12px;"
                                    required v-model="single_object.phone" 
                                    :maxlength="20"
                                    ref="input_phone_update"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-bottom:0px;">
                        
                        <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="fax"/>
                                <input type="text" 
                                    
                                    class="form-control  linea-form" 
                                    style="height: 1rem; font-size:12px;"
                                    required 
                                    v-model="single_object.fax" 
                                    :maxlength="20"
                                    ref="input_fax_update"
                                />
                            </div>
                        </div>
                        <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="director"/>
                                <input type="text" 
                                    
                                    class="form-control  linea-form" 
                                    style="height: 1rem; font-size:12px;"
                                    required v-model="single_object.director" 
                                    :maxlength="45"
                                    ref="input_director_update"
                                />
                            </div>
                        </div>
                        <div class="col-md-6" style="padding:5px;">
                            <div class="form-group">
                                <label v-html="director"/>
                                <input type="text" 
                                    
                                    class="form-control  linea-form" 
                                    style="height: 1rem; font-size:12px;"
                                    required v-model="single_object.director" 
                                    :maxlength="45"
                                    ref="input_director_update"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="col-12 col-md-6">
                <div class="row mb-0 no-gutters">
                    <div class="col-12 maps d-flex align-items-center justify-content-center">
                        Google Maps
                    </div>
                    <div class="col-12 p-0 mb-3 card cardModule hoverable">
                        <div class="card-content">
                            <div class="card-title">
                                <h2 class="subtitle--1">
                                    Note 1 / 05-13-20
                                </h2>
                            </div>
                            <p class="mt-3 card-content__text">
                                Ui venenatis ligula himenaeos malesuada purus per. Ut risus vehicula in taciti quisque natoque sagittis, habitasse cubilia condimentum orci egestas per proin.
                            </p>
                        </div>
                    </div>
                    <div class="col-12 p-0 card cardModule hoverable">
                        <div class="card-content">
                            <div class="card-title">
                                <h2 class="subtitle--1">
                                    Note 1 / 05-13-20
                                </h2>
                            </div>
                            <p class="mt-3 card-content__text">
                                Ui venenatis ligula himenaeos malesuada purus per. Ut risus vehicula in taciti quisque natoque sagittis, habitasse cubilia condimentum orci egestas per proin.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-right">
            <a href="/facilities" class="waves-effect waves-light btn btnTransparentF">
                <i class="prefix"></i>
                Back to facilities
            </a>
            <a class="waves-effect waves-light btn btnAddM right-aligned">
                <i class="prefix"></i>
                Save changes
            </a>
        </div>

        <WaitingModal/>
    </section>
</template>

<script>

import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb.vue'
import WaitingModal         from    '@/components/WaitingModal.vue'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name:   'FacilityDetail',

    components:{
        Breadcrumb,
        WaitingModal
    },
    data(){
        return{
            notyf,
            facility_id:    this.$route.params.id,
            rest_api:       this.$store.state.route_api_rest + 'facilities/',
            title_page:     '',
            content_header: this.$store.state.headers,
            single_object:  {},

            name:           "Name: <b style='color:red;'>*</b>",
            type:           "Type: <b style='color:red;'>*</b>",
            country:        "Country: <b style='color:red;'>*</b>",
            state:          "State: <b style='color:red;'>*</b>",
            address:        "Address: <b style='color:red;'>*</b>",
            zip_code:       "Zip Code: <b style='color:red;'>*</b>",
            email:          "Email: <b style='color:red;'>*</b>",
            phone:          "Phone: <b style='color:red;'>*</b>",
            fax:            "Fax: <b style='color:red;'>*</b>",
            director:       "Director: <b style='color:red;'>*</b>",

            breadcrumb:[
                {
                    name:   'Home',
                    href:   '/',
                    arrow:  "<span class='slash'>/</span>",
                },
                {
                    name:   'Facilities',
                    href:   '/facilities',
                    arrow:  "<span class='slash'>/</span>",
                },
            ],

            countries:              [],
            state_countries:        [],
            specialities:           [],
            facilities:             [],

        }
    },

    methods:{

        api_request(){
            window.$('#static-hold-modal').modal('show');
            let http_request = {
                id:             this.facility_id,
                states_request: false,
            }
            axios.get(this.rest_api+JSON.stringify(http_request)).then((response)=>{
                this.single_object      = response.data.facility;
                this.countries          = response.data.countries;
                this.state_countries    = response.data.states;
                this.specialities       = response.data.specialities;
                this.title_page         = this.single_object.name;
                const bread = {
                    name:   this.single_object.name,
                    href:   '#',
                    arrow:  " ",
                }
                this.breadcrumb.push(bread);
                setTimeout(()=>{
                    window.$('#static-hold-modal').modal('hide');
                }, 500);
            }).catch((error)=>{
                console.log(error);
            });
        },

    },

    mounted(){
        this.api_request();
    }
}
</script>